/**
 * Represents the Task Class.
 * @author Philipp Kamin <philipp.kamin@ateam.de>
 * @constructor
 * @param {Object} params - Parameters for Task.
 * @param {number} params.id - The Task ID.
 * @param {string} params.name - name of Task.
 * @param {string} params.description - Task Description.
 * @param {Object} params.created - Date object to represent create time.
 * @param {Object} params.deadline - Date object to represent a deadline date.
 * @param {number} params.businessValue - an integer to represent the business value of a Task.
 * @param {number} params.complexity - represent the complexity of a Task
 * @param {number} params.priority - represent the priority of a Task
 * @param {number} params.duration - represent the duration of a Task
 * @param {number} params.progress - an integeref between 0 and 100 to represent the progress of a Task 
 * @param {boolean} params.archive - Flag the Task as Archived.
 * @param {number} params.creatorId - User Id of the Task creator.
 * @param {number} params.parentId - Task ID to refere on another Task as Parent.
 * @param {number} params.projectId - ID of an Project.
 * @param {Object} params.updated - Date object to represent the last update.
 * @param {Object[]} params.tags - Array of Tag Objects.
 */
class Task {
    constructor(params) {
        var internal = {};

        if(params.name == undefined) {
            throw new TypeError('property name not found');
        }

        Object.defineProperty(this, 'progress',{
            enumerable: true,
            get: function(){ return internal.progress; },
            set: function(value){ 
                if(value === null || value === undefined) {
                    internal.progress = 0;
                    return;
                }

                if(value < 0) {
                    value = 0;
                }

                if(value > 100) {
                    value = 100;
                }
                
                internal.progress = value;
            }
        });

        Object.defineProperty(this, 'created',{
            enumerable: true,
            get: function(){ return internal.created; },
            set: function(value){ 
                if(value === null || value === undefined) {
                    internal.created = this.getCurrentDate();
                    return;
                }

                internal.created = value;
            }
        });

        /** @private @const */
        this.id = params.id !== undefined ? params.id : null;
        this.name = params.name !== undefined ? params.name : null;
        this.description = params.description !== undefined ? params.description : null;

        /** @private @const */
        this.created = params.created !== undefined ? params.created : null;

        this.deadline = params.deadline !== undefined ? params.deadline : null;
        this.businessValue = params.businessValue !== undefined ? params.businessValue : null;
        this.complexity = params.complexity !== undefined ? params.complexity : null;
        this.priority = params.priority !== undefined ? params.priority : null;
        this.duration = params.duration !== undefined ? params.duration : 0;
        this.progress = params.progress !== undefined ? params.progress : 0;
        this.archive = params.archive !== undefined ? params.archive : false;

        /** @private @const */
        this.creatorId = params.creatorId !== undefined ? params.creatorId : null;

        this.parentId = params.parentId !== undefined ? params.parentId : null;
        this.projectId = params.projectId !== undefined ? params.projectId : null;
        this.updated = params.updated !== undefined ? params.updated : null;

        this.tags = params.tags !== null ? params.tags : [];

    }

    /**
     * Get the Current Date
     * @return {string} return an Date String Format as yyyy-mm-dd
     */
    getCurrentDate() {
        let today = new Date(),
            dd = today.getDate(),
            mm = today.getMonth()+1, //January is 0!
            yyyy = today.getFullYear();
    
        if(dd<10) {
            dd = '0'+dd
        }
    
        if(mm<10) {
            mm = '0'+mm
        }
    
        return `${yyyy}-${mm}-${dd}`;
    }
}

exports.Task = Task;


// WEBPACK FOOTER //
// src/classes/task.class.js